import styles from "./devEnvironmentBanner.module.scss";

const isProduction = import.meta.env.VITE_SENTRY_ENV === "prod";

export const DevEnvironmentBanner = () => {
  if (isProduction) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <span className={styles.text}>Development Environment</span>
    </div>
  );
};
